var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-row",
        { staticStyle: { margin: "20px 0 20px 0" } },
        [
          !_vm.disabled
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.Sensory - _vm.reportDraft,
                      expression: "Sensory-reportDraft",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("visitPlan.draftSave")))]
              )
            : _vm._e(),
          !_vm.disabled
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.Sensory - _vm.reportSubmit,
                      expression: "Sensory-reportSubmit",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.submit")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "sensoryReportList" })
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.changeShow } },
            [_vm._v(_vm._s(_vm.isShow ? "隐藏标准" : "查看标准"))]
          ),
          !_vm.disabled
            ? [
                _c("br"),
                _c(
                  "label",
                  { staticStyle: { "font-size": "12px", color: "#F56C6C" } },
                  [_vm._v(_vm._s(_vm.$t("visitPlan.operationTips")))]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.firstHandleClick },
          model: {
            value: _vm.firstActiveName,
            callback: function ($$v) {
              _vm.firstActiveName = $$v
            },
            expression: "firstActiveName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "基础信息", name: "basicInfo" } },
            [
              _c(
                "el-form",
                {
                  ref: "report",
                  attrs: {
                    model: _vm.report,
                    disabled: _vm.disabled,
                    rules: _vm.reportRules,
                    "label-width": "150px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sensory.report.serialNo"),
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.report.reportNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.report, "reportNo", $$v)
                                  },
                                  expression: "report.reportNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sensory.report.name"),
                                prop: "fiveBitCodeName",
                              },
                            },
                            [
                              _vm.report.fiveBitCodeName &&
                              _vm.report.fiveBitCodeName.length > 13
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.report.fiveBitCodeName,
                                        placement: "top-start",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "handle-input",
                                        attrs: { clearable: "" },
                                        on: { focus: _vm.showTemplateName },
                                        model: {
                                          value: _vm.report.fiveBitCodeName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.report,
                                              "fiveBitCodeName",
                                              $$v
                                            )
                                          },
                                          expression: "report.fiveBitCodeName",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("el-input", {
                                    staticClass: "handle-input",
                                    attrs: { clearable: "" },
                                    on: { focus: _vm.showTemplateName },
                                    model: {
                                      value: _vm.report.fiveBitCodeName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.report,
                                          "fiveBitCodeName",
                                          $$v
                                        )
                                      },
                                      expression: "report.fiveBitCodeName",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sensory.report.rater"),
                                prop: "rater",
                              },
                            },
                            [
                              _c(
                                "el-autocomplete",
                                {
                                  staticClass: "inline-input",
                                  attrs: {
                                    "fetch-suggestions": _vm.querySearch,
                                    placeholder:
                                      _vm.$t("sensory.report.rater") +
                                      _vm.$t("common.splitBy", { split: "," }),
                                    debounce: 0,
                                    clearable: "",
                                  },
                                  on: {
                                    change: _vm.raterChange,
                                    select: _vm.selectQaLab,
                                  },
                                  model: {
                                    value: _vm.report.rater,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.report, "rater", $$v)
                                    },
                                    expression: "report.rater",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.searchRater()
                                      },
                                    },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                              _vm.report.raterQualified == "Y"
                                ? _c("i", {
                                    staticClass: "el-icon-success",
                                    staticStyle: { color: "green" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sensory.report.rateDate"),
                                prop: "rateDate",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.report.rateDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.report, "rateDate", $$v)
                                  },
                                  expression: "report.rateDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sensory.report.sampleSource"),
                                prop: "sampleSource",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  table: "TT_SENSORY",
                                  field: "SAMPLE_SOURCE",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.report.sampleSource,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.report, "sampleSource", $$v)
                                  },
                                  expression: "report.sampleSource",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("nav.plant"),
                                prop: "tmPlantName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.tableHeadData
                                    .map((plant) => plant.tmPlantName)
                                    .join(";"),
                                  disabled: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.remarks"),
                                prop: "remark",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { clearable: "", maxlength: "200" },
                                model: {
                                  value: _vm.report.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.report, "remark", $$v)
                                  },
                                  expression: "report.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "评估明细", name: "evaluationDetail" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "PickupPlantMulti",
                    _vm._b(
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.Sensory - _vm.reportAddPlant,
                            expression: "Sensory-reportAddPlant",
                          },
                        ],
                        attrs: {
                          "before-select": _vm.beforeSelectPlant,
                          disabled:
                            _vm.disabled ||
                            _vm.templateData == null ||
                            _vm.templateData.length == 0,
                        },
                        on: { "pick-up": _vm.addPlant },
                      },
                      "PickupPlantMulti",
                      _vm.fiveBitCodeObj,
                      false
                    )
                  ),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "tableForm",
                  staticClass: "scoreTable",
                  staticStyle: { padding: "20px 0" },
                  attrs: { model: _vm.tableHeadData },
                },
                [
                  _c(
                    "el-table",
                    {
                      ref: "scoreTable",
                      attrs: {
                        data: _vm.templateData,
                        "min-height": "500px",
                        "span-method": _vm.spanMethod,
                        "row-class-name": _vm.rowClassNameFun,
                        "cell-class-name": _vm.cellClassNameFun,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          "show-overflow-tooltip": "",
                          label: _vm.$t("sensory.template.detailName"),
                          prop: "title",
                          width: "160",
                          align: "center",
                        },
                      }),
                      _vm.isShow
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("sensory.template.criterion"),
                              "class-name": "template-detail",
                              "min-width": "380px",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.detailType == "TITLE"
                                        ? _c("div", [
                                            _vm._v(_vm._s(scope.row.detail)),
                                          ])
                                        : scope.row.detailType == "SCORE"
                                        ? _c("div", [
                                            _vm._v(_vm._s(scope.row.detail)),
                                          ])
                                        : _c("div", [
                                            scope.row.isComments == "Y"
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(scope.row.detail)
                                                  ),
                                                ])
                                              : _vm._e(),
                                            scope.row.isComments != "Y"
                                              ? _c(
                                                  "div",
                                                  [
                                                    _vm._l(9, function (i) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "template-detail-cell row1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row.detail.split(
                                                                "`"
                                                              )[i - 1] == ""
                                                                ? " 　"
                                                                : scope.row.detail.split(
                                                                    "`"
                                                                  )[i - 1]
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    }),
                                                    _vm._l(9, function (i) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "template-detail-cell row2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                scope.row
                                                                  .start > i ||
                                                                  scope.row
                                                                    .end < i
                                                                  ? " "
                                                                  : i
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }),
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3267195468
                            ),
                          })
                        : _vm._e(),
                      _vm._l(_vm.tableHeadData, function (plant, plantIndex) {
                        return _c(
                          "el-table-column",
                          {
                            key: "ab" + plantIndex,
                            attrs: {
                              label: plant.tmPlantName,
                              "header-align": "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "table_header_grandFather",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "table_header_father",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "table_header_input",
                                                },
                                                [
                                                  plantIndex == 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "table_header_input_label",
                                                        },
                                                        [
                                                          _c("p", [
                                                            _vm._v("工厂:"),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      class:
                                                        plantIndex == 0
                                                          ? "table_header_input_content1"
                                                          : "table_header_input_content2",
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "100%",
                                                          padding: "0px",
                                                          "margin-right":
                                                            "37px",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.disabled,
                                                          clearable: "",
                                                        },
                                                        on: {
                                                          focus: function (
                                                            $event
                                                          ) {
                                                            return _vm.openPlantDialog(
                                                              plantIndex
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.tableHeadData[
                                                              plantIndex
                                                            ].tmPlantName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.tableHeadData[
                                                                plantIndex
                                                              ],
                                                              "tmPlantName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tableHeadData[plantIndex].tmPlantName",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          !_vm.disabled
                                            ? _c("i", {
                                                staticClass: "el-icon-remove",
                                                staticStyle: {
                                                  color: "red",
                                                  display: "inline-block",
                                                  width: "14px",
                                                  height: "auto",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.delPlant(
                                                      plantIndex
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          _vm._l(plant.batches, function (batch, batchIndex) {
                            return _c("el-table-column", {
                              key: "ab" + batchIndex,
                              attrs: {
                                "min-width": "300px",
                                align: "center",
                                "header-align": "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "table_header_grandFather",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "table_header_father",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table_header_input",
                                                  },
                                                  [
                                                    batchIndex == 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "table_header_input_label",
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                "评估类型:"
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "div",
                                                      {
                                                        class:
                                                          plantIndex == 0
                                                            ? "table_header_input_content1"
                                                            : "table_header_input_content2",
                                                      },
                                                      [
                                                        _c("ic-select", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            padding:
                                                              "0px!important",
                                                          },
                                                          attrs: {
                                                            table: "TT_SENSORY",
                                                            field: "RATE_TYPE",
                                                            disabled:
                                                              _vm.disabled,
                                                            clearable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.tableHeadData[
                                                                plantIndex
                                                              ].batches[
                                                                batchIndex
                                                              ].rateType,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .tableHeadData[
                                                                  plantIndex
                                                                ].batches[
                                                                  batchIndex
                                                                ],
                                                                "rateType",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "tableHeadData[plantIndex].batches[batchIndex].rateType",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.isShowMore,
                                                        expression:
                                                          "isShowMore",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "table_header_input",
                                                  },
                                                  [
                                                    batchIndex == 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "table_header_input_label",
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v("批次号:"),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "div",
                                                      {
                                                        class:
                                                          plantIndex == 0
                                                            ? "table_header_input_content1"
                                                            : "table_header_input_content2",
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            padding: "0px",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              _vm.disabled,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.tableHeadData[
                                                                plantIndex
                                                              ].batches[
                                                                batchIndex
                                                              ].batchNo,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .tableHeadData[
                                                                  plantIndex
                                                                ].batches[
                                                                  batchIndex
                                                                ],
                                                                "batchNo",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "tableHeadData[plantIndex].batches[batchIndex].batchNo",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.isShowMore,
                                                        expression:
                                                          "isShowMore",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "table_header_input",
                                                  },
                                                  [
                                                    batchIndex == 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "table_header_input_label",
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v("保质期:"),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "div",
                                                      {
                                                        class:
                                                          plantIndex == 0
                                                            ? "table_header_input_content1"
                                                            : "table_header_input_content2",
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            padding: "0px",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              _vm.disabled,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.tableHeadData[
                                                                plantIndex
                                                              ].batches[
                                                                batchIndex
                                                              ].expDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .tableHeadData[
                                                                  plantIndex
                                                                ].batches[
                                                                  batchIndex
                                                                ],
                                                                "expDate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "tableHeadData[plantIndex].batches[batchIndex].expDate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.isShowMore,
                                                        expression:
                                                          "isShowMore",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "table_header_input",
                                                  },
                                                  [
                                                    batchIndex == 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "table_header_input_label",
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                "样品代码:"
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "div",
                                                      {
                                                        class:
                                                          plantIndex == 0
                                                            ? "table_header_input_content1"
                                                            : "table_header_input_content2",
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            padding: "0px",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              _vm.disabled,
                                                            type: "textarea",
                                                            maxlength: "200",
                                                            "show-word-limit":
                                                              "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.tableHeadData[
                                                                plantIndex
                                                              ].batches[
                                                                batchIndex
                                                              ].sampleCode,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .tableHeadData[
                                                                  plantIndex
                                                                ].batches[
                                                                  batchIndex
                                                                ],
                                                                "sampleCode",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "tableHeadData[plantIndex].batches[batchIndex].sampleCode",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            !_vm.disabled && batchIndex == 0
                                              ? _c("i", {
                                                  staticClass:
                                                    "el-icon-circle-plus",
                                                  staticStyle: {
                                                    color: "#f8ab01",
                                                    display: "inline-block",
                                                    width: "14px",
                                                    height: "auto",
                                                    "margin-right": "5px",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addBatch(
                                                        plantIndex,
                                                        batchIndex
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            !_vm.disabled
                                              ? _c("i", {
                                                  staticClass: "el-icon-remove",
                                                  staticStyle: {
                                                    color: "red",
                                                    display: "inline-block",
                                                    width: "14px",
                                                    height: "auto",
                                                    "margin-right": "5px",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.delBatch(
                                                        plantIndex,
                                                        batchIndex
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _c("i", {
                                              class: _vm.isShowMore
                                                ? "el-icon-arrow-up"
                                                : "el-icon-arrow-down",
                                              staticStyle: {
                                                color: "#f8ab01",
                                                display: "inline-block",
                                                width: "14px",
                                                height: "auto",
                                              },
                                              attrs: { circle: "" },
                                              on: { click: _vm.onShowMore },
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.detailType != "TITLE" &&
                                        scope.row.detailType != "SCORE" &&
                                        scope.row.isComments == "Y"
                                          ? _c(
                                              "el-form-item",
                                              {
                                                staticStyle: {
                                                  display: "inline-block",
                                                  width: "60%",
                                                },
                                                attrs: {
                                                  prop: `[${plantIndex}].batches[${batchIndex}].scores[${scope.row.index}]`,
                                                  rules: _vm.scoreRules.score2,
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "textarea",
                                                    disabled: _vm.disabled,
                                                    placeholder:
                                                      _vm.scoresPlaceholder(
                                                        _vm.disabled
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      batch.scores[
                                                        scope.row.index
                                                      ],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        batch.scores,
                                                        scope.row.index,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "batch.scores[scope.row.index]",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        scope.row.detailType != "TITLE" &&
                                        scope.row.detailType != "SCORE" &&
                                        scope.row.isComments != "Y"
                                          ? _c(
                                              "el-form-item",
                                              {
                                                staticStyle: {
                                                  display: "inline-block",
                                                  width: "60%",
                                                },
                                                attrs: {
                                                  prop: `[${plantIndex}].batches[${batchIndex}].scores[${scope.row.index}]`,
                                                  rules: _vm.scoreRules.score,
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "score",
                                                  attrs: {
                                                    max: scope.row.end,
                                                    min: scope.row.start,
                                                    disabled: _vm.disabled,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.tableHeadData[
                                                        plantIndex
                                                      ].batches[batchIndex]
                                                        .scores[
                                                        scope.row.index
                                                      ],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.tableHeadData[
                                                          plantIndex
                                                        ].batches[batchIndex]
                                                          .scores,
                                                        scope.row.index,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "tableHeadData[plantIndex].batches[batchIndex].scores[scope.row.index]",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        scope.row.detailType == "SCORE"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.countScore(
                                                    scope.row.scoreField,
                                                    batch
                                                  )
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          }),
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "附件", name: "attachment" } },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { type: "border-card" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "产品照片", name: "picture" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "picture",
                          class: { hide: _vm.disableEditor },
                          attrs: {
                            headers: _vm.header,
                            action: _vm.fileUploadUrl,
                            "file-list": _vm.picList,
                            "on-success": _vm.uploadSuccess,
                            accept:
                              ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP",
                            disabled: _vm.disabled,
                            multiple: "",
                            "list-type": "picture-card",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "file",
                              fn: function ({ file }) {
                                return _c(
                                  "div",
                                  { staticStyle: { height: "100%" } },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        "max-width": "100%",
                                        height: "auto",
                                        "object-fit": "contain",
                                      },
                                      attrs: { src: file.url, alt: "" },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-actions",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-preview",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handlePreview(file)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-zoom-in",
                                            }),
                                          ]
                                        ),
                                        file.tmDocumentId
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-delete",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadFile(
                                                      file
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-download",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        !_vm.disabled
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-delete",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.fileRemove(file)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              },
                            },
                          ]),
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "产品附件", name: "file" } },
                    [
                      _c(
                        "el-row",
                        { staticStyle: { "margin-bottom": "10px" } },
                        [
                          !_vm.disabled
                            ? _c(
                                "el-upload",
                                {
                                  ref: "upload",
                                  attrs: {
                                    "show-file-list": false,
                                    headers: _vm.header,
                                    action: _vm.fileUploadUrl,
                                    "before-upload": _vm.beforeUpload,
                                    "on-success": _vm.uploadSuccess,
                                    multiple: true,
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "primary" } },
                                    [_vm._v(_vm._s(_vm.$t("common.upload")))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.fileTableData,
                            border: "",
                            stripe: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "documentName", label: "附件" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadFile(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.documentName))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          !_vm.disabled
                            ? _c("el-table-column", {
                                attrs: { label: "操作", width: "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.delFile(
                                                    scope.row,
                                                    scope.$index,
                                                    "file"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete",
                                                staticStyle: { color: "red" },
                                              }),
                                              _vm._v("删除"),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3285947428
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showRaterDialog,
            "append-to-body": "",
            width: "80%",
            title: "评估人选择器",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRaterDialog = $event
            },
          },
        },
        [
          _c("pickupUser", {
            ref: "pickUpRaterDialog",
            attrs: { multi: true },
            on: { input: _vm.selectRater },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showTemplateNameDialog,
            width: "80%",
            title: "产品选择器",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showTemplateNameDialog = $event
            },
          },
        },
        [_c("PickupFiveBitCode", { on: { pickup: _vm.selectTemplateName } })],
        1
      ),
      _c("pickup-plant", {
        ref: "pickUpPlantDialog",
        attrs: {
          formSign: "sensoryReportDetail",
          pickUpPlantObj: _vm.pickUpPlantObj,
        },
        on: {
          "pick-up": function ($event) {
            return _vm.changePlant($event, _vm.plantIndex)
          },
        },
      }),
      _c(
        "el-dialog",
        {
          staticStyle: { "text-align": "center" },
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { height: "100%", width: "100%" },
            attrs: { src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }